var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.605,
    height: 20.605,
    viewBox: "0 0 20.605 20.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "tool",
    d: "M16,1.2a6.752,6.752,0,0,1,2.8.6A.8.8,0,0,1,19.036,3.1L15.269,6.862a.2.2,0,0,0,0,.276l1.593,1.593a.2.2,0,0,0,.276,0L20.9,4.964A.8.8,0,0,1,22.2,5.2a6.8,6.8,0,0,1-8.477,9.21L7.186,20.946a2.921,2.921,0,0,1-4.131-4.131L9.59,10.278A6.8,6.8,0,0,1,16,1.2Zm.982,1.693a5.2,5.2,0,0,0-5.721,7.251.8.8,0,0,1-.163.9l-6.91,6.91a1.321,1.321,0,0,0,1.869,1.869l6.91-6.91a.8.8,0,0,1,.9-.163,5.2,5.2,0,0,0,7.251-5.721L18.266,9.866l-.006.006a1.8,1.8,0,0,1-2.52,0l-.006-.006-1.6-1.6-.006-.006a1.81,1.81,0,0,1,0-2.52l.006-.006Z",
    transform: "translate(-2.2 -1.196)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.f2db3d8ca866384f91eaf967d92ab6b1.svg";
export { ForwardRef as ReactComponent };